import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

import Layout from "@components/layout/Layout";
import InfoPanel from "@components/form/InfoPanel";
import ReportTemplatesPanel from "@components/reports/adhoc/ReportTemplatesPanel";
import ReportSnapshotsPanel from "@components/reports/adhoc/ReportSnapshotsPanel";
import ReportingWorkspace, {
  ReportingSection,
} from "@components/reports/adhoc/ReportingWorkspace";

/**
 * CR-SEQ-2026-025 — the reporting hub: one page for templates and saved
 * snapshots, templates first, switched by the same left menu the scheme
 * dashboard uses, with the guidance panel every other console page carries.
 */
const ReportingHub: React.FunctionComponent = () => {
  const { t } = useTranslation();
  const { hash } = useLocation();
  // The URL remains the source of truth, so Back, refresh and deep links all
  // return to the same section of the reporting workspace.
  const activeSection: ReportingSection =
    hash === "#1" ? "history" : "templates";

  const templatesInfo = (
    <InfoPanel>
      <div className="space-y-4">
        <p>{t("reporting.templates_info1")}</p>
        <p>{t("reporting.templates_info2")}</p>
        <p>{t("reporting.templates_info3")}</p>
      </div>
    </InfoPanel>
  );

  const historyInfo = (
    <InfoPanel>
      <div className="space-y-4">
        <p>{t("reporting.history_info1")}</p>
        <p>{t("reporting.history_info2")}</p>
        <p>{t("reporting.history_info3")}</p>
      </div>
    </InfoPanel>
  );

  return (
    <Layout
      permissions={["ViewReports"]}
      breadcrumb={[
        { label: t("dashboard.dashboard"), href: "/polestar" },
        { label: t("reporting.hub_title") },
      ]}
      title={t("reporting.hub_title")}
    >
      <ReportingWorkspace
        activeSection={activeSection}
        infoPanel={activeSection === "templates" ? templatesInfo : historyInfo}
      >
        {activeSection === "templates" ? (
          <ReportTemplatesPanel />
        ) : (
          <ReportSnapshotsPanel />
        )}
      </ReportingWorkspace>
    </Layout>
  );
};

export default ReportingHub;
